import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Consultation from './pages/Consultation';
import DPP from './pages/DPP';
import Imprint from './pages/Imprint';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import SetPassword from './pages/SetPassword';
import Training from './pages/Training';
import LenisScroll from './components/LenisScroll';
import { AuthProvider, RequireAuth } from './lib/auth';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <LenisScroll />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/dpp" element={<DPP />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/register" element={<Register />} />
          {/* Landing page for the trial invite email (uid+token in the query). */}
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/set-password/" element={<SetPassword />} />
          <Route path="/training" element={<Training />} />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
